class Logger{

    info(tag: string, data: any) {
        let today = new Date();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        console.log(`${tag} ${time} ${JSON.stringify(data)}`);
    }
}

export default new Logger();